class LocationCache {
    constructor() {
        this.cache = new Map();
    }

    get(latitude, longitude) {
        const key = `${latitude},${longitude}`;
        return this.cache.get(key);
    }

    set(latitude, longitude, data) {
        const key = `${latitude},${longitude}`;
        this.cache.set(key, data);
    }

    clear() {
        this.cache.clear();
    }
}

const locationCache = new LocationCache();
export default locationCache;
